import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

import Button from '@/components-latest/primitives/Button'
import { EyeOff, EyeOpen } from '@/components-latest/primitives/Icons'
import Text from '@/components-latest/primitives/Text'

import Styles from './BalanceDetails.module.scss'

const RequestPayoutIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.69601 4.04782C6.7244 4.34918 5.7008 4.66667 4.66651 4.66667C3.98171 4.66667 3.36947 4.5939 2.8526 4.49459C2.50071 4.42698 2.26628 4.38222 2.09743 4.3599C2.06415 4.3555 2.03661 4.35243 2.01397 4.35034C2.01252 4.36501 2.01107 4.38227 2.00973 4.40239C2.0002 4.54589 1.99984 4.74656 1.99984 5.05924L1.99984 12.2248C1.99984 12.2496 1.99987 12.2655 2.00004 12.2779C2.00152 12.2802 2.00305 12.2826 2.00462 12.285C2.00618 12.2874 2.00773 12.2898 2.00926 12.292C2.35677 12.4393 3.14171 12.6667 4.66651 12.6667C5.8912 12.6667 6.97427 12.3616 8.05378 12.0295C8.13668 12.004 8.21998 11.9781 8.30367 11.9522C9.27528 11.6508 10.2989 11.3333 11.3332 11.3333C12.018 11.3333 12.6302 11.4061 13.1471 11.5054C13.499 11.573 13.7334 11.6178 13.9023 11.6401C13.9355 11.6445 13.9631 11.6476 13.9857 11.6497C13.9872 11.635 13.9886 11.6177 13.99 11.5976C13.9995 11.4541 13.9998 11.2534 13.9998 10.9408V3.77516C13.9998 3.75038 13.9998 3.73449 13.9996 3.7221C13.9982 3.71977 13.9966 3.71739 13.9951 3.71498C13.9935 3.71259 13.992 3.71024 13.9904 3.70796C13.6429 3.5607 12.858 3.33333 11.3332 3.33333C10.1085 3.33333 9.02542 3.63836 7.9459 3.97052C7.86301 3.99602 7.7797 4.02186 7.69601 4.04782ZM14.0647 11.6535C14.0661 11.6534 14.0672 11.6534 14.0672 11.6534L14.0647 11.6535ZM7.55378 2.69615C8.64093 2.36164 9.8912 2 11.3332 2C13.0302 2 14.0105 2.25927 14.557 2.50033C14.5586 2.50103 14.5603 2.5018 14.5622 2.50264C14.5911 2.5153 14.6573 2.54432 14.7301 2.59203C14.8042 2.64067 14.8661 2.69548 14.9204 2.7473C15.0043 2.82743 15.0746 2.92936 15.112 2.98687C15.1495 3.04438 15.2145 3.14976 15.2539 3.25892C15.3333 3.47871 15.3332 3.63477 15.3332 3.7662L15.3332 10.9633C15.3332 11.2469 15.3332 11.4927 15.3204 11.686C15.3084 11.8664 15.2813 12.1187 15.1515 12.3412C15.0808 12.4624 14.9885 12.5904 14.8532 12.7022C14.7179 12.814 14.5748 12.8804 14.4424 12.927C14.1899 13.0158 13.9138 12.9866 13.7275 12.9619C13.5152 12.9339 13.2419 12.8813 12.9165 12.8188L12.8955 12.8148C12.4513 12.7294 11.9237 12.6667 11.3332 12.6667C10.5101 12.6667 9.67595 12.9242 8.64893 13.2412C8.58209 13.2619 8.51443 13.2828 8.4459 13.3039C7.35875 13.6384 6.10849 14 4.66651 14C2.96948 14 1.9892 13.7407 1.44271 13.4997C1.44113 13.499 1.43937 13.4982 1.43746 13.4974C1.40856 13.4847 1.34234 13.4557 1.26963 13.408C1.1955 13.3593 1.1336 13.3045 1.07931 13.2527C0.995344 13.1726 0.92513 13.0706 0.887644 13.0131C0.850159 12.9556 0.785229 12.8502 0.745801 12.7411C0.666415 12.5213 0.666464 12.3652 0.666506 12.2338L0.666507 5.03671C0.666499 4.75306 0.666491 4.50726 0.679331 4.314C0.691317 4.1336 0.718349 3.88135 0.848212 3.65878C0.918909 3.53762 1.01114 3.40959 1.14647 3.29779C1.28179 3.18599 1.42492 3.11957 1.55725 3.07301C1.80974 2.98416 2.08584 3.01343 2.27216 3.03806C2.48453 3.06614 2.75781 3.11865 3.08321 3.18118L3.10419 3.18521C3.54837 3.27055 4.07595 3.33333 4.66651 3.33333C5.48956 3.33333 6.32373 3.07581 7.35075 2.75876C7.4176 2.73812 7.48526 2.71723 7.55378 2.69615ZM11.9998 5.33333C12.368 5.33333 12.6665 5.63181 12.6665 6V8.66667C12.6665 9.03486 12.368 9.33333 11.9998 9.33333C11.6317 9.33333 11.3332 9.03486 11.3332 8.66667V6C11.3332 5.63181 11.6317 5.33333 11.9998 5.33333ZM7.99984 7C7.44756 7 6.99984 7.44771 6.99984 8C6.99984 8.55228 7.44756 9 7.99984 9C8.55213 9 8.99984 8.55228 8.99984 8C8.99984 7.44771 8.55213 7 7.99984 7ZM5.66651 8C5.66651 6.71133 6.71118 5.66667 7.99984 5.66667C9.28851 5.66667 10.3332 6.71133 10.3332 8C10.3332 9.28866 9.28851 10.3333 7.99984 10.3333C6.71118 10.3333 5.66651 9.28866 5.66651 8ZM3.99984 6.66667C4.36803 6.66667 4.66651 6.96514 4.66651 7.33333V10C4.66651 10.3682 4.36803 10.6667 3.99984 10.6667C3.63165 10.6667 3.33317 10.3682 3.33317 10V7.33333C3.33317 6.96514 3.63165 6.66667 3.99984 6.66667Z"
        fill="#837C9F"
      />
    </svg>
  )
}

type Props = {
  balanceAmount: number
  currency: string
}

const BalanceDetails = ({ balanceAmount, currency }: Props) => {
  const { t } = useTranslation()
  const [isAmountVisible, setIsAmountVisible] = useState(true)

  return (
    <div className={Styles.wrapper} data-testid="wallet-balance-details">
      <div className={Styles.balanceBlock}>
        <Text variant="nextBody" className={Styles.label}>
          {t('billing.wallet.current-balance')}
        </Text>
        <div className={Styles.amountRow}>
          <Text
            variant="nextTitle-2"
            weight="semiBold"
            className={Styles.amount}>
            {isAmountVisible
              ? balanceAmount.toFixed(2).replace('.', ',')
              : '*****'}
          </Text>
          {isAmountVisible && (
            <Text variant="heading-05" weight="semiBold">
              {currency}
            </Text>
          )}
          <button
            type="button"
            className={Styles.visibilityToggle}
            aria-label="toggle-current-balance-visibility"
            onClick={() => {
              setIsAmountVisible(previous => !previous)
            }}>
            {isAmountVisible ? <EyeOpen /> : <EyeOff />}
          </button>
        </div>
      </div>
      <Button
        className={Styles.requestPayoutButton}
        shape="rounded"
        size="small"
        variant="secondary"
        disabled
        icon={<RequestPayoutIcon />}>
        {t('billing.wallet.request-payout')}
      </Button>
    </div>
  )
}

export default BalanceDetails
